import { render, staticRenderFns } from "./Textlist.vue?vue&type=template&id=18a40ed3&"
import script from "./Textlist.vue?vue&type=script&lang=js&"
export * from "./Textlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../DigitalRetail/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports